import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectSettings } from '../components/ProjectSettings';
import { employeeProjectModelService } from '../services/employeeProjectModelService';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/project-settings/employee-project-models')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!user) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }

    if (!isAdmin(user.role)) {
      // For non-admin users, access will be checked by the backend
      // Backend will return 403 if user has no project role assignments
      // Frontend will handle the error gracefully
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.prefetchQuery({
      queryKey: ['employee-project-models'],
      queryFn: () => employeeProjectModelService.getEmployeeProjectModels(),
      staleTime: 1000 * 60 * 5,
    });
  },
  component: ProjectSettingsComponent,
});

function ProjectSettingsComponent() {
  return <ProjectSettings />;
}
